module.exports = __webpack_public_path__ + "static/media/swaziland.936ef008.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/portfolio/swaziland.png
// module id = 331
// module chunks = 0